<owl-carousel-o class="banner-carousel" [options]="dataSignal().carouselOptions">
  @for (banner of dataSignal().carouselSlide; track banner) { @if (banner.mobile_image_url) {
  <ng-template carouselSlide>
    @if (banner.link_url) {
    <a [href]="banner.link_url" target="_blank">
      <picture>
        <source media="(min-width: 801px)" [srcset]="replaceBucket.replaceBucket(banner.pc_image_url)" />
        <img
          class="img-banner"
          [src]="replaceBucket.replaceBucket(banner.mobile_image_url)"
          [alt]="banner.title"
          [title]="banner.title"
          loading="eager"
          fetchpriority="high"
          width="500"
          height="500"
        />
      </picture>
      <!-- <img
        class="img-pc"
        [src]="replaceBucket.replaceBucket(banner.pc_image_url)"
        [alt]="banner.title"
        [title]="banner.title"
        loading="eager"
        fetchpriority="high"
      />
      <img
        class="img-mobile"
        [src]="replaceBucket.replaceBucket(banner.mobile_image_url)"
        [alt]="banner.title"
        [title]="banner.title"
        loading="eager"
        fetchpriority="high"
        width="500"
        height="500"
      /> -->
    </a>
    } @if (!banner.link_url) {
    <picture>
      <source media="(min-width: 801px)" [srcset]="replaceBucket.replaceBucket(banner.pc_image_url)" />
      <img
        class="img-banner"
        [src]="replaceBucket.replaceBucket(banner.mobile_image_url)"
        [alt]="banner.title"
        [title]="banner.title"
        loading="eager"
        fetchpriority="high"
        width="500"
        height="500"
      />
    </picture>
    <!-- <img
      class="img-pc"
      [src]="replaceBucket.replaceBucket(banner.pc_image_url)"
      [alt]="banner.title"
      [title]="banner.title"
      loading="eager"
      fetchpriority="high"
    />
    <img
      class="img-mobile"
      [src]="replaceBucket.replaceBucket(banner.mobile_image_url)"
      [alt]="banner.title"
      [title]="banner.title"
      loading="eager"
      fetchpriority="high"
      width="500"
      height="500"
    /> -->
    }
  </ng-template>
  } }
</owl-carousel-o>
